// extracted by mini-css-extract-plugin
export default {"wrapper":"fp-z","response":"gp-z","error":"hp-z","disabled":"ip-z","buttons":"jp-z","feedbackQuestionSection":"kp-z","yesNoWrapper":"lp-z"};